var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAidaLogoNewLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03085 33.5249L0.822571 36.5214C0.453417 36.7331 0 36.4644 0 36.0369L0.0200627 1.33652C0.0200627 0.310535 1.11549 -0.332743 1.99022 0.180251L19.2361 10.261C19.4408 10.3791 19.5651 10.5989 19.5651 10.8351V17.3126C19.5651 17.6587 19.192 17.8785 18.8991 17.7035L6.45618 10.3424L6.44012 32.8164C6.44012 33.1096 6.28364 33.3824 6.03085 33.5249ZM25.5559 7.18302L25.5398 29.657L13.0969 22.296C12.8 22.1209 12.4308 22.3367 12.4308 22.6868V29.1644C12.4308 29.4005 12.5552 29.6204 12.7599 29.7385L30.0058 39.8192C30.8805 40.3322 31.9799 39.693 31.9799 38.6629L32 3.96256C32 3.53507 31.5466 3.26636 31.1774 3.47807L25.9692 6.4746C25.7164 6.62117 25.5599 6.88988 25.5599 7.18302H25.5559Z",
    fill: "url(#paint0_linear_5474_1384)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5474_1384",
    x1: -0.513605,
    y1: 1.78845,
    x2: 55.9823,
    y2: 62.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9803FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8809F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4026D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidaLogoNewLight);
export default __webpack_public_path__ + "static/media/AIDA_logo_new_light.cb99f336587ae3ca2afb65c822639b9c.svg";
export { ForwardRef as ReactComponent };